import {
  type PulseBlockFragment,
  type PulseFragment,
  type PulseIndexPagePulseFragment,
  PulseV1PulseBlockState,
  PulseV1PulseBlockType,
} from '@spotify/confidence-graphql';

export type Pulse = PulseFragment;
export type PulseListItem = PulseIndexPagePulseFragment;
export type PulseBlock = PulseBlockFragment;
export type PulseBlockState = NonNullable<PulseBlock['state']>;
export type PulseBlockType = NonNullable<PulseBlock['blockType']>;

export const PULSE_BLOCK_STATE = {
  ACTIVE: PulseV1PulseBlockState.Active,
  ERROR: PulseV1PulseBlockState.Error,
  PENDING: PulseV1PulseBlockState.Pending,
} as const satisfies Record<'ACTIVE' | 'ERROR' | 'PENDING', PulseBlockState>;

export const PULSE_BLOCK_TYPE = {
  CHART: PulseV1PulseBlockType.PulseBlockTypeChart,
  TABLE: PulseV1PulseBlockType.PulseBlockTypeTable,
  BIG_NUMBER: PulseV1PulseBlockType.PulseBlockTypeBigNumber,
  TEXT: PulseV1PulseBlockType.PulseBlockTypeText,
} as const satisfies Record<
  'CHART' | 'TABLE' | 'BIG_NUMBER' | 'TEXT',
  PulseBlockType
>;

export const PULSE_BLOCK_TYPES: readonly PulseBlockType[] = [
  PULSE_BLOCK_TYPE.CHART,
  PULSE_BLOCK_TYPE.TABLE,
  PULSE_BLOCK_TYPE.BIG_NUMBER,
  PULSE_BLOCK_TYPE.TEXT,
];

export type SaveToPulseSourceInput = {
  projectName?: string;
  sourceChat: string;
  sourceEvent?: string;
};

export type SaveToPulseInput = SaveToPulseSourceInput & {
  blockType: PulseBlockType;
  suggestedName: string;
  visualizationSpec?: unknown;
  selectedContent?: string;
};
